module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"load_selected":"Load selected snapshot","new_snapshot":"Create new snapshot","delete_selected":"Delete selected snapshot"},"fr":{"load_selected":"Charge la sauvegarde sélectionnée","new_snapshot":"Nouvelle sauvegarde","delete_selected":"Supprimer la sauvegarde séelctionnée"}}')
  delete Component.options._Ctor
}
